import type {
  CoreItemCategoryListMeta,
  CoreItemCategory,
  ParameterID,
  CoreApiResponseListV2,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Get a item category
 *
 * @endpoint GET /api/me/item_categories/{internal_id}
 * @scope saas
 * @see https://flecto.dev/api-4724138
 */

export async function getItemCategoryById(
  internal_id: ParameterID
): Promise<
  CoreApiResponseListV2<
    'item_category',
    CoreItemCategory,
    CoreItemCategoryListMeta
  >
> {
  const { data } = await api.get(`/api/me/item_categories/${internal_id}`)

  return data
}
